import AdModel from "../../domain/models/ad.model";
import FileUpload from "../../domain/models/fileUpload.model";
import BaseApi from "../api/base.api";


class AdService {
    private baseApi: BaseApi;

    private uriAdd: string;

    constructor() {
        this.baseApi = new BaseApi();
        this.uriAdd = 'catalogo/publicidad';
    }

    public getAllAds = async (): Promise<AdModel[]> => {
        const response = await this.baseApi.apliClient.get<AdModel[]>(this.uriAdd);
        return response.data;
    }

    public createAd = async (ad: AdModel): Promise<AdModel> => {
        const response = await this.baseApi.apliClient.post<AdModel>(this.uriAdd, ad);
        return response.data;
    }

    public updateAd = async (ad: AdModel): Promise<AdModel> => {
        const response = await this.baseApi.apliClient.put<AdModel>(`${this.uriAdd}/${ad.id}`, ad);
        return response.data;
    }

    public deleteAd = async (id: number): Promise<void> => {
        await this.baseApi.apliClient.delete(`${this.uriAdd}/${id}`);
    }

    public uploadAdImage = async (file: File): Promise<FileUpload> => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await this.baseApi.apliClient.post<FileUpload>(`${this.uriAdd}/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    }
}

export default AdService;